import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
// import logo from "../../assets/images/Group 1.png";
// import LoginModal from "../Authentication/Modal/page/LoginModal";
// import RegisterModal from "../Authentication/Modal/page/RegisterModal";
// import VerifyModal from "../Authentication/Modal/page/VerifyModal";
// Redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import {
  Button,
  Container,
  NavbarBrand,
  NavbarText,
  ModalBody,
  ModalHeader,
  Modal,
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
// import {
//   changeLayout,
//   changeLayoutMode,
//   changeLayoutPosition,
//   changeLayoutWidth,
//   changeLeftsidebarSizeType,
//   changeLeftsidebarViewType,
//   changeSidebarImageType,
//   changeSidebarTheme,
//   changeSidebarVisibility,
//   changeTopbarTheme,
// } from "../../../../slices/thunks";

// import BookPackages from "../Pages/Packages/Pages/BookPackage";
import Header from "../../Layouts/Header";
import Footer from "../../Layouts/Footer";
import { useModal } from "../../Context/ModalContext";
import {
  changeLayout,
  changeLayoutMode,
  changeLayoutPosition,
  changeLayoutWidth,
  changeLeftsidebarSizeType,
  changeLeftsidebarViewType,
  changeSidebarImageType,
  changeSidebarTheme,
  changeSidebarVisibility,
  changeTopbarTheme,
} from "../../slices/thunks";
import TravelLinkService from "../../services/TravelLinkService/TravelLinkService";

const LandingAuth = ({ children }) => {
  const dispatch = useDispatch();

  const selectLayoutState = (state) => state.Layout;
  const selectLayoutProperties = createSelector(
    selectLayoutState,
    (layout) => ({
      layoutType: "horizontal",
      leftSidebarType: layout.leftSidebarType,
      layoutModeType: layout.layoutModeType,
      layoutWidthType: layout.layoutWidthType,
      layoutPositionType: layout.layoutPositionType,
      topbarThemeType: layout.topbarThemeType,
      leftsidbarSizeType: layout.leftsidbarSizeType,
      leftSidebarViewType: layout.leftSidebarViewType,
      leftSidebarImageType: layout.leftSidebarImageType,
      preloader: layout.preloader,
      sidebarVisibilitytype: layout.sidebarVisibilitytype,
    })
  );

  const {
    layoutType,
    leftSidebarType,
    layoutModeType,
    layoutWidthType,
    layoutPositionType,
    topbarThemeType,
    leftsidbarSizeType,
    leftSidebarViewType,
    leftSidebarImageType,
    preloader,
    sidebarVisibilitytype,
  } = useSelector(selectLayoutProperties);

  const [user, setUser] = useState(null);

  const [headerClass, setHeaderClass] = useState("");

  useEffect(() => {
    if (
      layoutType ||
      leftSidebarType ||
      layoutModeType ||
      layoutWidthType ||
      layoutPositionType ||
      topbarThemeType ||
      leftsidbarSizeType ||
      leftSidebarViewType ||
      leftSidebarImageType ||
      sidebarVisibilitytype
    ) {
      window.dispatchEvent(new Event("resize"));
      dispatch(changeLeftsidebarViewType(leftSidebarViewType));
      dispatch(changeLeftsidebarSizeType(leftsidbarSizeType));
      dispatch(changeSidebarTheme(leftSidebarType));
      dispatch(changeLayoutMode(layoutModeType));
      dispatch(changeLayoutWidth(layoutWidthType));
      dispatch(changeLayoutPosition(layoutPositionType));
      dispatch(changeTopbarTheme(topbarThemeType));
      dispatch(changeLayout(layoutType));
      dispatch(changeSidebarImageType(leftSidebarImageType));
      dispatch(changeSidebarVisibility(sidebarVisibilitytype));
    }
  }, [
    layoutType,
    leftSidebarType,
    layoutModeType,
    layoutWidthType,
    layoutPositionType,
    topbarThemeType,
    leftsidbarSizeType,
    leftSidebarViewType,
    leftSidebarImageType,
    sidebarVisibilitytype,
    dispatch,
  ]);

  useEffect(() => {
    window.addEventListener("scroll", scrollNavigation, true);
    return () => {
      window.removeEventListener("scroll", scrollNavigation, true);
    };
  }, []);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  useEffect(() => {
    const hamburgerIcon = document.querySelector(".hamburger-icon");
    if (hamburgerIcon) {
      if (
        sidebarVisibilitytype === "show" ||
        layoutType === "vertical" ||
        layoutType === "twocolumn"
      ) {
        hamburgerIcon.classList.remove("open");
      } else {
        hamburgerIcon.classList.add("open");
      }
    }
  }, [sidebarVisibilitytype, layoutType]);

  const scrollNavigation = () => {
    const scrollup = document.documentElement.scrollTop;
    if (scrollup > 50) {
      setHeaderClass("topbar-shadow");
    } else {
      setHeaderClass("");
    }
  };

  const onChangeLayoutMode = (value) => {
    if (changeLayoutMode) {
      dispatch(changeLayoutMode(value));
    }
  };
  // Modal states
  // const [modalLogin, setModalLogin] = useState(false);
  // const [modalSignup, setModalSignup] = useState(false);
  // const [modalVerify, setModalVerify] = useState(false);

  // // Toggling modals
  // const toggleLogin = () => setModalLogin(!modalLogin);
  // const toggleSignup = () => setModalSignup(!modalSignup);
  // const toggleVerify = () => setModalVerify(!modalVerify);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", scrollNavigation, true);
    return () => window.removeEventListener("scroll", scrollNavigation, true);
  }, []);

  return (
    <>
      <Header headerClass={headerClass} />

      <div style={{ backgroundColor: "#F5FCFF", height: "100%" }}>
        {children}
      </div>

      <Footer />

      {/* Modals */}
      {/* <LoginModal
        isOpen={modalLogin}
        toggle={toggleLogin}
        onSignUp={toggleSignup}
        onVerify={toggleVerify}
      />
      <RegisterModal
        isOpen={modalSignup}
        toggle={toggleSignup}
        onLogin={toggleLogin}
        onVerify={toggleVerify}
      />
      <VerifyModal isOpen={modalVerify} toggle={toggleVerify} /> */}
    </>
  );
};

LandingAuth.propTypes = {
  children: PropTypes.node,
};

export default LandingAuth;

// const LandingAuth = ({ children }) => {
//   const [user, setUser] = useState(null);
//   const [headerClass, setHeaderClass] = useState("");
//   const [modalLogin, setModalLogin] = useState(false);
//   const [modalSignup, setModalSignup] = useState(false);
//   const [modalVerify, setModalVerify] = useState(false);

//   console.log("modalLogin1", modalLogin);
//   console.log("modalSignup1", modalSignup);
//   console.log("modalVerify1", modalVerify);

//   useEffect(() => {
//     const storedUser = localStorage.getItem("user");
//     if (storedUser) {
//       setUser(JSON.parse(storedUser));
//     }
//   }, []);
//   // Toggle functions
//   const toggleLogin = useCallback(() => setModalLogin((prev) => !prev), []);
//   console.log("toggleLogin1", toggleLogin);

//   const toggleSignup = useCallback(() => setModalSignup((prev) => !prev), []);
//   console.log("toggleSignup1", toggleSignup);

//   const toggleVerify = useCallback(() => setModalVerify((prev) => !prev), []);
//     console.log("toggleVerify1", toggleVerify);

//   return (
//     <>
//       {user ? (
//         <Header headerClass={headerClass} />
//       ) : (
//         <Container fluid>
//           <header
//             id="page-topbar"
//             className={headerClass}
//             style={{ paddingTop: "7px", height: "90px" }}
//           >
//             <div className="layout-width">
//               <div className="navbar-header">
//                 <div className="d-flex align-items-center justify-content-between">
//                   <div className="navbar-brand-box horizontal-logo">
//                     <Link
//                       to={user ? "/booking" : "/package"}
//                       className="logo logo-dark d-flex align-items-center"
//                     >
//                       <img
//                         src={logo}
//                         alt="Cosmos Logo"
//                         style={{ height: "auto", width: "auto" }}
//                       />
//                     </Link>
//                   </div>
//                 </div>
//                 <div className="d-flex gap-4 justify-content-end align-content-end w-100 w-lg-50">
//                   <Button
//                     onClick={toggleLogin}
//                     style={{
//                       color: "#fe7d29",
//                       backgroundColor: "transparent",
//                       border: "none",
//                     }}
//                   >
//                     Login
//                   </Button>
//                   <Button
//                     style={{ backgroundColor: "#FE7D29", border: "none" }}
//                     onClick={toggleSignup}
//                   >
//                     Sign Up
//                   </Button>
//                 </div>
//               </div>
//             </div>
//           </header>
//         </Container>
//       )}
//       <div style={{ backgroundColor: "#F3F5F8", height: "100%" }}>
//         {children}
//       </div>
//       <Footer />

//       {/* Modals */}
//       <LoginModal
//         isOpen={modalLogin}
//         toggle={toggleLogin}
//         onSignUp={toggleSignup}
//         onVerify={toggleVerify}
//       />
//       <RegisterModal
//         isOpen={modalSignup}
//         toggle={toggleSignup}
//         onLogin={toggleLogin}
//         onVerify={toggleVerify}
//       />
//       <VerifyModal isOpen={modalVerify} toggle={toggleVerify} />

//       {/* {user && ( */}
//         {/* <BookPackages
//         modalLogin={modalLogin} // Pass modal state
//         toggleLogin={toggleLogin} // Pass toggle function
//         modalSignup={modalSignup} // Pass modal state
//         toggleSignup={toggleSignup} // Pass toggle function
//         modalVerify={modalVerify} // Pass modal state
//          toggleVerify={toggleVerify} // Pass toggle function
//       /> */}
//       {/* )}  */}
//     </>
//   );
// };

// LandingAuth.propTypes = {
//   children: PropTypes.node,
// };

// export default LandingAuth;
